import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_LCBS = "GetListCoursesByStatus";
export const GET_LMEnroll = "GetListEnrollmentStudent";
export const GET_DCById = "GetDefinitionCourseById";
export const GET_DCByIdEnroll = "GetDefinitionCourseByIdEnroll";
export const GetUserBadge = "GetNameByBadge";
export const CEC_LOADING = "CEC_LOADING";
export const ADD_Enroll = "ADD_Enroll";
export const DLT_Enroll = "DLT_Enroll";
export const CHK_Enroll = "CHK_Enrollment";
export const UPDATE_Email = "UPDATE_Email";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  }
});


export const GetListCoursesByStatus = (id, tipo, badge) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.get(`/Enrollment/GetListCoursesByStatus/${id}&${tipo}&${badge}&${Token}`).then((res => {
      dispatch({
        type: GET_LCBS,
        data: res.data
      });
      console.log("Resp", res);
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const GetListEnrollmentStudent = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.get(`/Enrollment/GetListEnrollmentStudent/${id}&${Token}`).then((res => {
      dispatch({
        type: GET_LMEnroll,
        data: res.data
      });
      console.log("Resp", res);
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const GetCouseScheduleById = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.get(`/DefinitionCourse/GetDefinitionCourseById/${id}&${Token}`).then((res => {
      dispatch({
        type: GET_DCById,
        data: res.data
      })
      console.log("Resp", res);
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const GetCourseScheduleByIdEnroll = (id, std) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.get(`/DefinitionCourse/GetDefinitionCourseByIdEnroll/${id}&${std}&${Token}`).then((res => {
      dispatch({
        type: GET_DCByIdEnroll,
        data: res.data
      })
      console.log("Resp", res);
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const GetUserByBadge = (Badge) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.get(`/Enrollment/GetNameByBadge/${Badge}&${Token}`).then((res => {
      dispatch({
        type: GetUserBadge,
        data: res.data
      })
      console.log("Resp", res);
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const addEnroll = (id, badge, user, email) =>{
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.put(`/Enrollment/PutInsEnrollment/${id}&${badge}&${user}&${email}&${Token}` ).then((res => {
         dispatch({
             type: ADD_Enroll,
             data: res.data
         });
         console.log(res.data)
     })).catch(function(error){
       console.log("Error", error);
     });
 }
}

export const updateEmail = (id, badge, email) =>{
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.put(`/Enrollment/PutInsUpdtEmail/${id}&${badge}&${email}&${Token}` ).then((res => {
         dispatch({
             type: UPDATE_Email,
             data: res.data
         });
         console.log(res.data)
     })).catch(function(error){
       console.log("Error", error);
     });
 }
}

export const dltEnroll = (idEnr, idDec, user) =>{
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.put(`/Enrollment/PutDltEnrollmentStudent/${idEnr}&${idDec}&${user}&${Token}` ).then((res => {
         dispatch({
             type: DLT_Enroll,
             data: res.data
         });
         console.log(res.data)
     })).catch(function(error){
       console.log("Error", error);
     });
 }
}

export const chkEnroll = (badge, idDec) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CEC_LOADING
    });
    await instance.get(`/Enrollment/GetCheckIsEnrollment/${badge}&${idDec}&${Token}`).then((res => {
      dispatch({
        type: CHK_Enroll,
        data: res.data
      })
    }
    )).catch(function (error) {
      console.log("Error", error);
    });
  }
};